import React from "react";

export default function footer() {
  return (
    <div className="bg-gray-900 flex flex-col justify-center items-center py-7 text-sm   text-gray-500 sm:order-first sm:mt-0 ">
      <p className=" ">&copy; 2025</p>
      <p>
        Developed by <span className="text-teal-500">Lulama Cele</span>
      </p>
    </div>
  );
}
